import { TableCell, TableRow } from '@mui/material'
import { ReportsType } from '@/enums'
import { GlobalReportLibraryColumnProps } from '@/state/reports/models'

export interface Props {
  row: GlobalReportLibraryColumnProps
  reportType: string
}

const ReportsTableRowComponent = ({ row, reportType }: Props) => {
  return (
    <TableRow hover>
      {reportType === ReportsType.BY_PLAYER_ID && (
        <TableCell>{row.playerId}</TableCell>
      )}
      {reportType !== ReportsType.BY_PLAYER_ID && (
        <TableCell>
          {reportType === ReportsType.BY_CATEGORY
            ? row.gameCategoryName || row.name || '-'
            : reportType === ReportsType.BY_GAME
              ? row.gameName || row.name || '-'
              : reportType === ReportsType.BY_PROVIDER
                ? row.gameProviderName || row.name || '-'
                : row.name || '-'}
        </TableCell>
      )}
      {reportType !== ReportsType.BY_BRAND && (
        <TableCell>{row.rounds}</TableCell>
      )}
      {reportType === ReportsType.BY_BRAND ? (
        <>
          <TableCell>{row.totalBetsText}</TableCell>
          <TableCell>{row.totalWinsText}</TableCell>
        </>
      ) : (
        <>
          <TableCell>{row.betsText}</TableCell>
          <TableCell>{row.winsText}</TableCell>
        </>
      )}
      <TableCell>{row.gameWinText}</TableCell>
      <TableCell>{row.rtpText}</TableCell>
    </TableRow>
  )
}

export default ReportsTableRowComponent
